import { type FC, useMemo } from "react";

import { InfoBox } from "@/components/InfoBox";
import { MotifIcon } from "@/components/MotifIcon";
import { Trans } from "@/features/i18n/Trans";
import { useProductNotActivated } from "@/features/unify-scope-setting/ProfileUnificationWarning/useProductNotActivated";

/**
 * Design:
 * [Figma](https://www.figma.com/design/k0XwP83RAV16nVdyFx7crb/Omnichannel?node-id=7554-197407&m=dev)
 */
export const RequireActivate: FC = () => {
  const productNotActivated = useProductNotActivated();

  const product = useMemo(
    function computeProduct() {
      return productNotActivated.map((s) => s.toUpperCase()).join(", ");
    },
    [productNotActivated],
  );

  if (productNotActivated.length === 0) return null;

  return (
    <InfoBox
      icon={<MotifIcon un-i-motif="circle_info" />}
      variant="warning"
      description={
        <Trans
          i18nKey="feature.activationWarning.message"
          values={{
            product,
          }}
          components={{
            strong: <strong />,
          }}
        />
      }
    />
  );
};
